import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useCrimeAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const crime = ref({})
  const isSubmitting = ref(false)
  const collection = 'crime'

  async function create(data) {
    if (!hasPermission('crimes', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        client_id: oid(userData.client.$oid),
        history: [createInitialAuditEntry()],
      }

      if (data.name?.value) payload.name = data.name.value
      if (data.description?.value) payload.description = data.description.value
      if (data.lawNumber?.value) payload.lawNumber = data.lawNumber.value
      if (data.law?.value) payload.law = data.law.value
      if (data.article?.value) payload.article = data.article.value
      if (data.number?.value) payload.number = data.number.value

      await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.crime_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.crime_add_error'))
    } finally {
      router.push({ name: 'organization-crime-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    crime,
    isSubmitting,
  }
}
